import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

function Header() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileMenu(false);
  }, [location.pathname]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/career", label: "Career" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 1000,
        background: scrolled ? "rgba(26,10,46,0.96)" : "rgba(26,10,46,0.35)",
        backdropFilter: "blur(12px)",
        transition: "all 0.4s ease",
        boxShadow: scrolled ? "0 4px 30px rgba(214,36,110,0.18)" : "none",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{
          width: "92%",
          margin: "auto",
          minHeight: "74px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 0",
          gap: "16px",
        }}
      >
        <Link to="/" style={{ textDecoration: "none", flexShrink: 0 }}>
          <motion.div
            whileHover={{ scale: 1.03 }}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <img
              src="/logo.jpeg"
              alt="Artem Clava Logo"
              style={{
                width: window.innerWidth < 768 ? "46px" : "56px",
                height: window.innerWidth < 768 ? "46px" : "56px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid var(--gold)",
              }}
            />

            <div style={{ display: "flex", alignItems: "baseline", gap: "5px", flexWrap: "wrap" }}>
              <span
                style={{
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontWeight: 900,
                  fontSize: window.innerWidth < 768 ? "1.2rem" : "1.8rem",
                  color: "#fff",
                }}
              >
                ARTEM
              </span>
              <span
                style={{
                  fontFamily: "var(--font-hand)",
                  fontSize: window.innerWidth < 768 ? "1.4rem" : "2rem",
                  color: "var(--gold)",
                  fontWeight: 700,
                }}
              >
                Clava
              </span>
            </div>
          </motion.div>
        </Link>

        <button
          onClick={() => setMobileMenu(!mobileMenu)}
          className="mobile-menu-btn"
          style={{
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "12px",
            color: "white",
            padding: "10px 12px",
            cursor: "pointer",
            display: "none",
          }}
        >
          ☰
        </button>

        <nav className={`nav-links ${mobileMenu ? "mobile-open" : ""}`}>
          {links.map(({ to, label }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                style={{ textDecoration: "none", position: "relative" }}
              >
                <motion.span
                  whileHover={{ color: "var(--gold)" }}
                  style={{
                    fontFamily: "var(--font-sans)",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    color: active ? "var(--gold)" : "#fff",
                    padding: "10px 16px",
                    borderRadius: "20px",
                    display: "inline-block",
                    background: active
                      ? "rgba(232,160,32,0.15)"
                      : "transparent",
                    border: active
                      ? "1px solid rgba(232,160,32,0.4)"
                      : "1px solid transparent",
                    transition: "all 0.3s ease",
                  }}
                >
                  {label}
                </motion.span>
              </Link>
            );
          })}
        </nav>
      </motion.div>
    </header>
  );
}

export default Header;
